import * as amplitude from "@amplitude/analytics-browser"
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser"
import { amplitudeKey } from "./aws-exports"
import store from "src/redux/Store.ts"
import { PROPERTIES_TO_SEND_BY_EVENT } from "src/amplitude-categories"
import { isFedRampEnvironment } from "src/utils/CommonMethods"

// Checking whether this is report page or normal app pages
const isReport =
  String(window?.location?.pathname).startsWith("/report/") ||
  String(window?.location?.pathname).startsWith("/DIreport/")

// Skipping amplitude functionality on report generation pages using puppeteer

function init() {
  const API_KEY = amplitudeKey

  // Create and Install Session Replay Plugin
  const sessionReplayTracking = sessionReplayPlugin()
  amplitude.add(sessionReplayTracking)
  const identify = new amplitude.Identify()

  if (API_KEY && API_KEY !== "") {
    //Do not initialize if no API Key
    amplitude.init(API_KEY, null, {
      defaultTracking: "true",
      "config.autocapture.attribution": "false"
      //config.minIdLength -> Default 5 characters for identifiers such as deviceId and userId, can change here
    })
  }

  return { identify }
}

const { identify } = isReport || isFedRampEnvironment() ? { identify: null } : init()

const identifyEvent = (data) => {
  if (isReport || isFedRampEnvironment()) return

  // Always capture viewport and screen data
  const viewportAndScreenData = {
    viewport: `${window.innerWidth} x ${window.innerHeight}`,
    "screen resolution": `${window.screen.width} x ${window.screen.height}`
  }

  const userDataToSend = {
    "user id": store?.getState()?.userData?.userInfo?.data?.id,
    "user type": store?.getState()?.userData?.userInfo?.data?.type?.name,
    "role names": store?.getState()?.userData?.roles,
    "client id": "Command Center",
    "job title": store?.getState()?.userData?.userInfo?.data?.jobTitle,
    "primary sales office":
      store?.getState()?.userData?.userInfo?.data?.primarySalesOfficeId,
    version: import.meta.env?.VITE_AWS_JOB_ID,
    ...viewportAndScreenData
  }
  const finalProperties = data
    ? { ...viewportAndScreenData, ...data }
    : userDataToSend

  Object.entries(finalProperties).forEach(([key, value]) => {
    identify.set(key, value)
  })
  amplitude.identify(identify)
  amplitude.setUserId(store?.getState()?.appData?.userInfo?.data?.id)
}

const trackEvent = (event, options = {}) => {
  if (isReport || isFedRampEnvironment()) return

  const userDataToSend = {
    "client id": "Command Center"
  }
  const mergedProperties = {
    ...(PROPERTIES_TO_SEND_BY_EVENT[event] || {}),
    ...userDataToSend
  }
  //const mergedProperties = {}
  amplitude.track(event, {
    ...Object.keys(mergedProperties || {}).reduce(
      (result, key) =>
        typeof mergedProperties[key] === "function"
          ? { ...result, [key]: mergedProperties[key]() }
          : { ...result, [key]: mergedProperties[key] },
      {}
    ),
    ...options
  })
}

// Track viewport changes on resize
const updateViewportTracking = () => {
  if (isFedRampEnvironment()) return
  const viewportIdentify = new amplitude.Identify()
  viewportIdentify.set(
    "viewport",
    `${window.innerWidth} x ${window.innerHeight}`
  )
  viewportIdentify.set(
    "screen resolution",
    `${window.screen.width} x ${window.screen.height}`
  )
  amplitude.identify(viewportIdentify)
}

// Debounce function to avoid too many updates
let resizeTimeout
const handleResize = () => {
  clearTimeout(resizeTimeout)
  resizeTimeout = setTimeout(() => {
    updateViewportTracking()
  }, 500) // Wait 500ms after resize stops
}

// Set up resize listener if window is available
if (typeof window !== "undefined") {
  window.addEventListener("resize", handleResize)
}

export { amplitude, trackEvent, identifyEvent, updateViewportTracking }

